<div class="inner-content" ridangoAppTrapFocus>
    <div class="flex-align-center bottom-0 left-0 right-0 top-0 !flex">
        <div class="flex-column flex h-full w-full rounded-2xl bg-white text-base">
            <div class="flex-align-center relative my-6 !flex">
                <p class="orb-app-light-dark:font-bold align-center flex-1 font-semibold" mat-dialog-title>
                    {{ 'TICKET_PURCHASE_ACTIVATE_SAME_VALIDITY_CONFIRM_TITLE' | translate }}
                </p>
            </div>
            <div class="align-center box-border flex-1 overflow-y-auto px-4" mat-dialog-content>
                {{ 'TICKET_PURCHASE_ACTIVATE_SAME_VALIDITY_CONFIRM_TEXT' | translate }}
            </div>

            <div class="m-4 mt-0">
                <ion-button
                    class="btn--link btn--maximal btn--big link--no-line link--no-hover orb-app-light:text-secondary mt-4 rounded-lg text-primary dark:text-contrast-yellow"
                    (click)="cancel()"
                    mat-dialog-close
                    cdkFocusInitial
                    size="large"
                    fill="clear">
                    <ion-icon
                        class="pr-2 text-[2rem]"
                        *ngIf="env.PURCHASE_FLOW?.SHOW_SET_OTHER_TIME_BUTTON_ICON"
                        aria-hidden="true"
                        src="{{ assetsPath$ | async }}/img/purchase-flow-v2/products/period.svg">
                    </ion-icon>
                    <ion-label class="text-base font-semibold normal-case">
                        {{ 'TICKET_PURCHASE_ACTIVATE_SAME_VALIDITY_CONFIRM_SET_OTHER' | translate }}
                    </ion-label>
                </ion-button>

                <div class="flex">
                    <button
                        class="btn--primary vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black orb-app-light:text-black orb-app-light-dark:font-semibold h-14 w-full rounded-lg font-bold shadow-[0px_1px_2px_0px_#0000004D] dark:bg-contrast-yellow dark:text-contrast-black"
                        (click)="continueWithSame()"
                        type="submit">
                        {{ 'TICKET_PURCHASE_ACTIVATE_SAME_VALIDITY_CONFIRM_CONTINUE' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
